<template>
  <div class="upload-wrap">
    <div class="img-wrap" v-if="urls || readonly">
      <img :src="urls" alt="图片" v-if="urls" />
      <div v-if="!urls">暂无图片数据</div>
      <el-button
        type="text"
        class="img-close"
        @click="onClose"
        v-if="!readonly"
      >
        <i class="el-icon-circle-cross"></i>
      </el-button>
    </div>
    <el-upload
      v-else
      v-model="uploadUrl"
      :action="`${$util.domain}${actionUrl}`"
      :with-credentials="true"
      accept="image/*"
      name="uploadFile"
      type="drag"
      :thumbnail-mode="true"
      :show-file-list="false"
      :on-success="onSuccess"
      :on-error="onError"
      :on-remove="onRemove"
    >
      <div>
        <i class="el-icon-upload"></i>
        <div class="el-dragger__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
      </div>
      <div class="el-upload__tip upload-tips" slot="tip">{{ tips }}</div>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: {
    actionUrl: {
      type: String,
      default: "/adminapi/v1/basicTools/upload/one?uploadImageType=3",
    },
    keys: {
      type: String,
      default: "keys",
    },
    urls: {
      type: String,
      default: "",
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    tips: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      uploadUrl: "",
    };
  },
  watch: {
    urls: {
      handler(value) {
        this.uploadUrl = value;
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * 删除图片
     */
    onClose() {
      this.uploadUrl = "";
      this.$emit("onUrls", this.uploadUrl, this.keys);
    },
    /* 上传图片成功 */
    onSuccess(response) {
      if (response.error !== 10000) {
        this.$util.errorMsg("上传失败");
      } else {
        this.uploadUrl = response.data;
        this.$emit("onUrls", this.uploadUrl, this.keys);
      }
    },
    /**上传文件失败钩子**/
    onError(response) {
      this.uploadUrl = "";
      this.$emit("onUrls", this.uploadUrl, this.keys);
      if (response.status === 403) {
        this.SIGNOUT();
        location.href = "/#";
      }
      this.$util.errorMsg("上传失败");
    },
    onRemove() {
      this.uploadUrl = "";
      this.$emit("onUrls", this.uploadUrl, this.keys);
    },
  },
};
</script>

<style>
.upload-wrap .el-upload,
.upload-wrap .el-dragger {
  width: 100%;
}
.upload-wrap .img-wrap {
  position: relative;
  width: 100%;
  height: 180px;
  line-height: 180px;
  border: 1px solid #c0ccda;
  border-radius: 4px;
  text-align: center;
}
.upload-wrap .img-wrap img {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.upload-wrap .img-close {
  position: absolute;
  top: -7px;
  right: -7px;
  padding: 0;
}
.upload-tips {
  text-align: left !important;
  line-height: 1;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// index.vue?674a6988